import { render, staticRenderFns } from "./requestOrder.vue?vue&type=template&id=4b4d4bd2&scoped=true"
import script from "./requestOrder.vue?vue&type=script&lang=js"
export * from "./requestOrder.vue?vue&type=script&lang=js"
import style0 from "./requestOrder.vue?vue&type=style&index=0&id=4b4d4bd2&prod&lang=scss"
import style1 from "./requestOrder.vue?vue&type=style&index=1&id=4b4d4bd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d4bd2",
  null
  
)

export default component.exports